module.exports = __webpack_public_path__ + "img/xqxh4.02d23c30.png";